module.exports = __webpack_public_path__ + "media/images/ringrevenue/bg_tfoot-1af8eebf48af1884c9ef28923da9cdcf.gif";